export default "__VITE_ASSET__2b100c81__"